import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {

  public type: string = "player";
  public date_from: string;
  public date_to: string;

  constructor(private http: HttpService) { }

  ngOnInit(): void {
  }

  async export() {

    if (!this.type) {
      alert("Please select a type");
      return;
    }

    switch (this.type) {
      case "player":
      case "new-register":
      case "agent":
        await this.exportPlayer();
        break;
    }
  }

  async exportPlayer() {

    const player = await this.http.post("/admin/export/player", {
      type: this.type,
      date_from: this.date_from,
      date_to: this.date_to
    });
    console.log(player)

    let header = ['id', 'code', 'name', 'mobile', 'can_login', 'referral_code', 'payment_account', 'payment_bank', 'status', 'timestamp'];

    if (this.type == 'agent') {
      header.push('referral_name');
    }

    let csvData = this.convertToCSV(player, header);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", this.type + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  convertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ',' + (array[i][head] ? array[i][head] : '');
      }
      str += line + '\r\n';
    }
    return str;
  }
}
